'use strict';

module.exports = function(
  $scope,
  ServiceModal,
  OfficeModel,
  ObjectModel,
  Notification,
  gettextCatalog,
  DatepickerSettings,
  Tarif590DA,
  SubscriptionDA,
) {
  $scope.backupGroups = {};
  $scope.office = null;
  $scope.groups = [];
  $scope.pickedGroup = '';
  $scope.objects = [];
  $scope.needPremium = false;
  $scope.isSecondTimeWeekly = false;
  $scope.colors = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B',
    '#999999',
    '#000000',
  ];
  $scope.unitFactors = [];
  $scope.tariffServices;
  $scope.currentTariffService;
  var serviceMoved = false;
  var initWatchFired = false;

  $scope.filter = {
    start: moment()
      .subtract(6, 'month')
      .toDate(),
    end: new Date(),
  };
  $scope.dtpOptionsDateRangeStart = angular.copy(DatepickerSettings.default);
  $scope.dtpOptionsDateRangeEnd = angular.copy(DatepickerSettings.default);

  SubscriptionDA.get().then(function(response) {
    $scope.showPremiumNotification = response.onlyBasicFunctions;
  });

  this.setCurrentItem = function(service) {
    OfficeModel.get(function(error, response) {
      if (error) {
        console.error(error);
      } else {
        $scope.office = response;
        var count = 0;

        Tarif590DA.list().then(function(tariffServices) {
          $scope.tariffServices = tariffServices;
        });

        if ($scope.office.tariff590Allowed) {
          for (var i = 1; i <= 24; i++) {
            $scope.unitFactors.push({
              label: i.toString(),
              value: i,
            });
          }
        }

        if ($scope.office.serviceGroups instanceof Array) {
          for (var i = 0, groups = $scope.office.serviceGroups.length; i < groups; i++) {
            $scope.groups.push($scope.office.serviceGroups[i].name);

            count += $scope.office.serviceGroups[i].services.length;
          }
        }

        // new service
        if (!service) {
          service = {
            price: '',
            duration: 30,
            preparation: 0,
            followup: 0,
            color: 'default',
            resources: {
              employee: [],
              room: [],
              other: [],
            },
          };

          // get objects for service:employee matching
          ObjectModel.get(function(error, response) {
            if (!error) {
              $scope.objects = response;
              for (var i = 0, resLen = $scope.objects.length; i < resLen; i++) {
                var resource = $scope.objects[i];

                service.resources[resource.type].push(resource._id);
              }
            }
          });

          $scope.office.serviceGroups[0].services.push(service);
          $scope.pickedGroup = $scope.office.serviceGroups[0].name;
        } else {
          var index = -1;
          // find old group and delete service
          for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
            index = $scope.office.serviceGroups[i].services.indexOf(service);

            if (index > -1) {
              $scope.pickedGroup = $scope.office.serviceGroups[i].name;

              break;
            }
          }
        }

        service.timeOffer = service.timeOffer || { mode: 'disabled' };

        if (service.timeOffer.start) {
          service.timeOffer.start = new Date(service.timeOffer.start);
        }

        if (service.timeOffer.end) {
          service.timeOffer.end = new Date(service.timeOffer.end);
        }

        service.color = service.color || 'default';
        service.preparation = service.preparation || 0;
        service.followup = service.followup || 0;
        $scope.currentService = service;
        $scope.backupGroups = angular.copy($scope.office.serviceGroups);
      }
    });
  };

  /**
   * reset the data made in appointment form if push abort button
   */
  $scope.abort = function() {
    for (var prob in $scope.backupGroups) {
      if ($scope.office.serviceGroups.hasOwnProperty(prob)) {
        $scope.office.serviceGroups[prob] = $scope.backupGroups[prob];
      }
    }

    ServiceModal.close();
  };

  /**
   * move service to selected group
   */
  $scope.$watch('pickedGroup', function(newValue, oldValue) {
    if (newValue !== oldValue) {
      serviceMoved = true;
      moveService();
    }
  });

  /**
   * save current appointment to database
   */
  $scope.save = function() {
    $scope.showValidation = true;

    if ($scope.currentService.price === '') {
      delete $scope.currentService.price;
    }

    if ($scope.currentService.color === 'default') {
      delete $scope.currentService.color;
    }

    if (shorthandExists()) {
      Notification.addErrorMessage(gettextCatalog.getString('shorthand already used'));
    } else if ($scope.serviceForm.$valid) {
      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
        } else {
          $scope.showValidation = false;
          Notification.addSuccessMessage(
            gettextCatalog.getString('Service "{{name}}" saved', {
              name: $scope.currentService.name,
            }),
          );
          ServiceModal.close();
        }
      });
    }
  };

  /**
   * delete current appointment
   */
  $scope.delete = function() {
    var index = -1;
    // find old group and delete service
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      index = $scope.office.serviceGroups[i].services.indexOf($scope.currentService);

      for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
        if (angular.equals($scope.office.serviceGroups[i].services[j], $scope.currentService)) {
          index = j;
          break;
        }
      }

      if (index > -1) {
        $scope.office.serviceGroups[i].services.splice(index, 1);
        break;
      }
    }

    if (index > -1) {
      OfficeModel.update($scope.office, function(error) {
        if (error) {
          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
        } else {
          Notification.addSuccessMessage(
            gettextCatalog.getString('Service "{{name}}" deleted', {
              name: $scope.currentService.name,
            }),
          );
          ServiceModal.close();
        }
      });
    } else {
      Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
    }
  };

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.addWeeklyTime = function(index) {
    var firstEndTime = $scope.currentService.timeOffer.weekPlan[index].times[0].end;

    $scope.currentService.timeOffer.weekPlan[index].times.push({
      start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
      end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240,
    });

    $scope.isSecondTimeWeekly = true;
  };

  $scope.removeWeeklyTime = function(index) {
    $scope.currentService.timeOffer.weekPlan[index].times.splice(1, 1);
    $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
  };

  $scope.currentTariffChanged = function() {
    console.log($scope.currentTariffService);
  };

  /**
   * move the service to chosen service group
   */
  function moveService() {
    var index = -1;
    // find old group and delete service
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      index = $scope.office.serviceGroups[i].services.indexOf($scope.currentService);

      if (index > -1) {
        $scope.office.serviceGroups[i].services.splice(index, 1);
        break;
      }
    }

    // move to new group
    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
      if ($scope.office.serviceGroups[i].name === $scope.pickedGroup) {
        $scope.office.serviceGroups[i].services.push($scope.currentService);
      }
    }
  }

  /**
   * check if a shorthand already is taken
   * @returns {boolean}
   */
  function shorthandExists() {
    var count = 0;
    if ($scope.currentService.shorthand) {
      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
        for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
          if (
            $scope.office.serviceGroups[i].services[j].shorthand === $scope.currentService.shorthand
          ) {
            count++;
          }
        }
      }
    }

    if (count < 2) {
      return false;
    } else {
      return true;
    }
  }

  function setMinMaxDate() {
    $scope.dtpOptionsDateRangeStart.maxDate =
      $scope.currentService.timeOffer.end ||
      moment()
        .add(1, 'month')
        .toDate();
    $scope.dtpOptionsDateRangeEnd.minDate = $scope.currentService.timeOffer.start || new Date();
  }

  function checkSecondTimeWeekly() {
    var secondTimeIndex = _.findIndex(
      _.get($scope, 'currentService.timeOffer.weekPlan', []),
      function(day) {
        return day.times.length > 1;
      },
    );

    return secondTimeIndex > -1 ? true : false;
  }

  $scope.$watch(
    'currentService.timeOffer',
    function(newValue) {
      switch (newValue.mode) {
        case 'disabled':
          delete $scope.currentService.timeOffer.weekPlan;
          delete $scope.currentService.timeOffer.start;
          delete $scope.currentService.timeOffer.end;
          break;
        case 'dateRange':
          if (
            !$scope.currentService.timeOffer.start ||
            !moment($scope.currentService.timeOffer.start).isValid()
          ) {
            $scope.currentService.timeOffer.start = moment()
              .startOf('day')
              .toDate();
          }

          if (
            !$scope.currentService.timeOffer.end ||
            !moment($scope.currentService.timeOffer.end).isValid()
          ) {
            $scope.currentService.timeOffer.end = moment()
              .add(1, 'month')
              .endOf('day')
              .toDate();
          }

          delete $scope.currentService.timeOffer.weekPlan;
          break;
        case 'time':
          if (!_.isArray($scope.currentService.timeOffer.weekPlan)) {
            $scope.currentService.timeOffer.weekPlan = [];

            for (var i = 0; i < 7; i++) {
              $scope.currentService.timeOffer.weekPlan.push({
                available: false,
                times: [],
              });
            }

            _.forEach($scope.office.openingHours.regular, function(openingHour, index) {
              var day = $scope.currentService.timeOffer.weekPlan[index];
              day.available = openingHour.open;
              day.times = openingHour.times;
            });
          }

          delete $scope.currentService.timeOffer.start;
          delete $scope.currentService.timeOffer.end;
          break;
      }

      if (newValue.mode === 'time') {
        $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
      }

      setMinMaxDate();
      initWatchFired = true;
    },
    true,
  );
};



// WEBPACK FOOTER //
// ./src/app/modules/service/modal/serviceModalCtrl.js